__turbopack_context__.v({
  "className": "inter_da30b465-module__fBvOLq__className",
});
